const state = {
    userInfo: {
        token: '',
        uid: ''
    },
    searchOptionUid: ''
}

const getters = {
    userInfo: (state) => {
        return state.userInfo
    },
    searchOptionUid: (state) => {
        return state.searchOptionUid
    },
}

const actions = {
    user_getSearchOptionUid({
        commit
    }, params) {
        commit('setSearchOptionUid', params)
    }

}
const mutations = {
    setSearchOptionUid(state, params) {
        state.searchOptionUid = params
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}